export default __webpack_public_path__ + "static/media/banner-image.e340f395.png";